import * as React from "react";

const ChevronLeftRound: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM15.4797 18.0065L9.5 12L15.4797 5.9935C16.0035 5.46736 15.9442 4.60033 15.3536 4.15039C14.8647 3.7779 14.1758 3.82424 13.7411 4.25885L6 12L13.7411 19.7411C14.1758 20.1758 14.8647 20.2221 15.3536 19.8496C15.9442 19.3997 16.0035 18.5326 15.4797 18.0065Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronLeftRound);
